"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _typeaheadList = require("./typeaheadList.style");
var _typeahead = require("./typeahead.style");
var _typeahead2 = require("./typeahead.util");
var _Typeahead = require("./Typeahead.Menu");
var _Typeahead2 = require("./Typeahead.Options");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const TypeaheadInput = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      className = 'typeahead',
      options = [],
      grouped = false,
      markinput = false,
      maxListHeight,
      noresult,
      maxSuggestions = (0, _typeahead2.getmaxsuggestions)(_typeahead2.MAX_MATCHES),
      value = '',
      selectType = 'select',
      id = 'input',
      onChange,
      onSuggestionSelect,
      searchCriteriaMinLength,
      searchCriteriaChange,
      defaulHighLighttValue,
      menuIsOpen = false
    } = props,
    rest = __rest(props, ["className", "options", "grouped", "markinput", "maxListHeight", "noresult", "maxSuggestions", "value", "selectType", "id", "onChange", "onSuggestionSelect", "searchCriteriaMinLength", "searchCriteriaChange", "defaulHighLighttValue", "menuIsOpen"]);
  //onchange input state
  const [inputText, setInputText] = (0, _react.useState)(value);
  //keyboard navigation select state
  const [hoveredVal, setHoveredVal] = (0, _react.useState)('');
  //mouse movement state
  const [mouseEnter, setMouseEnter] = (0, _react.useState)(false);
  //processed options holding state
  const [suggestion, setSuggestion] = (0, _react.useState)(options);
  //toggle state for showing options or suggestion in typeahead
  const [showSuggestion, setShowSuggestion] = (0, _react.useState)(false);
  //state to hold the existing selected val
  const [selectedSuggestion, setSelectedSuggestion] = (0, _react.useState)(null);
  //Ul element ref to find active child scroll purpose
  const myUlRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _a, _b, _c, _d;
    const optionsTemp = Array.isArray(options) ? options : (0, _toConsumableArray2["default"])(options);
    if (optionsTemp === null || optionsTemp === void 0 ? void 0 : optionsTemp.length) {
      const filteredValue = inputText.replace(/[^a-zA-Z0-9]/g, '');
      setSuggestion((0, _typeahead2.callSetSuggestion)(options, grouped, maxSuggestions, filteredValue, inputText, noresult));
    }
    //scrolling to active li element
    if (myUlRef && (myUlRef === null || myUlRef === void 0 ? void 0 : myUlRef.current)) {
      (_d = (_c = (_b = (_a = myUlRef === null || myUlRef === void 0 ? void 0 : myUlRef.current) === null || _a === void 0 ? void 0 : _a.querySelector) === null || _b === void 0 ? void 0 : _b.call(_a, '.active')) === null || _c === void 0 ? void 0 : _c.scrollIntoView) === null || _d === void 0 ? void 0 : _d.call(_c, {
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [inputText, maxSuggestions, noresult, options, searchCriteriaMinLength, selectedSuggestion, value, hoveredVal]);
  const onMouseEnter = () => {
    setMouseEnter(true);
  };
  const onMouseLeave = () => {
    setMouseEnter(false);
  };
  const onInputClick = () => {
    if (suggestion && suggestion.length) {
      setShowSuggestion(true);
    }
  };
  const onInputBlur = () => {
    if (!mouseEnter) {
      setShowSuggestion(false);
    }
  };
  const onInputChange = e => {
    setInputText(e.target.value);
    setShowSuggestion(true);
    if (typeof onChange === 'function') {
      onChange === null || onChange === void 0 ? void 0 : onChange(e);
    }
  };
  const onClear = () => {
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect('');
    }
    setInputText('');
  };
  const onSuggestionClick = item => {
    setInputText(item.value ? item.value : item.text || '');
    setSelectedSuggestion(item);
    setShowSuggestion(false);
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect(item);
    }
    if (searchCriteriaMinLength && inputText.length > searchCriteriaMinLength && typeof onSuggestionSelect === 'function') {
      searchCriteriaChange === null || searchCriteriaChange === void 0 ? void 0 : searchCriteriaChange(item);
    }
    setMouseEnter(false);
  };
  const renderSuggestions = () => {
    let groupedSuggestions;
    if (grouped) {
      groupedSuggestions = suggestion === null || suggestion === void 0 ? void 0 : suggestion.reduce((suggestions, item) => {
        var _a;
        const {
          group
        } = item;
        suggestions[group] = (_a = suggestions[group]) !== null && _a !== void 0 ? _a : [];
        suggestions[group].push(item);
        return suggestions;
      }, {});
    }
    const hide = menuIsOpen ? !menuIsOpen : selectType === 'input' ? searchCriteriaMinLength && (searchCriteriaMinLength === null || searchCriteriaMinLength === void 0 ? void 0 : searchCriteriaMinLength.toString()) !== 'undefined' && searchCriteriaMinLength > inputText.length || !showSuggestion || inputText.length === 0 : searchCriteriaMinLength && (searchCriteriaMinLength === null || searchCriteriaMinLength === void 0 ? void 0 : searchCriteriaMinLength.toString()) !== 'undefined' && searchCriteriaMinLength > inputText.length || !showSuggestion;
    return (0, _jsxRuntime.jsx)(_Typeahead.TypeaheadMenu, (0, _extends2["default"])({
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      maxListHeight: maxListHeight ? maxListHeight : _typeahead2.MAX_MATCHES * 50 + 'px',
      "$hide": hide,
      ref: myUlRef
    }, {
      children: grouped ? Object.entries(groupedSuggestions).map((option, idx) => {
        return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [option[0] !== 'undefined' && (0, _jsxRuntime.jsx)(_typeaheadList.Components.Item, (0, _extends2["default"])({
            staticItem: true
          }, {
            children: (0, _jsxRuntime.jsx)(_typeaheadList.Components.Content, {
              children: (0, _jsxRuntime.jsx)("p", {
                children: option[0]
              })
            })
          }), idx), (0, _jsxRuntime.jsx)(_Typeahead2.TypeaheadOptions, {
            options: option[1],
            grouped: grouped,
            inputText: inputText,
            hoveredVal: hoveredVal,
            defaulHighLighttValue: defaulHighLighttValue,
            noresult: noresult,
            disabled: rest === null || rest === void 0 ? void 0 : rest.disabled,
            markinput: markinput,
            onSuggestionClick: onSuggestionClick
          })]
        });
      }) : (0, _jsxRuntime.jsx)(_Typeahead2.TypeaheadOptions, {
        options: suggestion,
        onSuggestionClick: onSuggestionClick,
        grouped: grouped,
        inputText: inputText,
        hoveredVal: hoveredVal,
        defaulHighLighttValue: defaulHighLighttValue,
        noresult: noresult,
        disabled: rest === null || rest === void 0 ? void 0 : rest.disabled,
        markinput: markinput
      })
    }));
  };
  //focus option is for keyboard navigation or traversal value in typeahead its used inside keydown handler
  const focusOption = direction => {
    var _a, _b;
    if (!suggestion.length) return;
    let nextFocus = 0; // handles 'first'
    const focusedIndex = suggestion.findIndex(option => (0, _typeahead2.isValidMatch)(option, hoveredVal, grouped));
    switch (direction) {
      case 'up':
        if (hoveredVal) {
          nextFocus = focusedIndex > 0 ? focusedIndex - 1 : suggestion.length - 1;
        }
        if ((_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion[nextFocus]) === null || _a === void 0 ? void 0 : _a.disabled) {
          nextFocus = nextFocus - 1;
        }
        setHoveredVal(() => {
          var _a;
          return (_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion[nextFocus]) === null || _a === void 0 ? void 0 : _a.value;
        });
        break;
      case 'down':
        if (hoveredVal) nextFocus = (focusedIndex + 1) % suggestion.length;
        if ((_b = suggestion === null || suggestion === void 0 ? void 0 : suggestion[nextFocus]) === null || _b === void 0 ? void 0 : _b.disabled) {
          nextFocus = nextFocus + 1;
        }
        setHoveredVal(() => {
          var _a;
          return (_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion[nextFocus]) === null || _a === void 0 ? void 0 : _a.value;
        });
        break;
    }
  };
  // Keyboard navigation handling handling on keydown event
  const onKeyDown = event => {
    switch (event === null || event === void 0 ? void 0 : event.key) {
      case 'Enter':
        if (!showSuggestion) {
          setShowSuggestion(true);
        }
        if (hoveredVal) {
          setInputText(hoveredVal);
        }
        break;
      case 'Escape':
        setShowSuggestion(false);
        break;
      case 'ArrowUp':
        focusOption('up');
        break;
      case 'ArrowDown':
        focusOption('down');
        break;
      default:
        return;
    }
    event.stopPropagation();
  };
  return (0, _jsxRuntime.jsxs)(_typeahead.Components.Wrapper, (0, _extends2["default"])({
    className: className,
    onKeyDown: onKeyDown
  }, {
    children: [(0, _jsxRuntime.jsx)(_typeahead.Components.InputElement, (0, _extends2["default"])({
      id: id,
      value: inputText,
      onClick: onInputClick,
      onChange: onInputChange,
      onBlur: onInputBlur,
      clearButton: true,
      onClear: onClear,
      ref: ref,
      onFocus: onInputClick,
      focus: showSuggestion
    }, rest)), renderSuggestions()]
  }));
});
var _default = exports["default"] = TypeaheadInput;